import { DEEP_LINK_BASE } from "@modules/common/constants";

/** Native medication log history (See history / Med history). */
export const MEDICATION_HISTORY_DEEPLINK = `${DEEP_LINK_BASE}?open=MEDICATION_HISTORY`;

/** Native medication tracker / log flow (Log). */
export const MEDICATION_TRACKER_DEEPLINK = `${DEEP_LINK_BASE}?open=MEDICATION_TRACKER`;
